import { render, staticRenderFns } from "./Bean.vue?vue&type=template&id=db59e550&scoped=true&"
import script from "./Bean.vue?vue&type=script&lang=js&"
export * from "./Bean.vue?vue&type=script&lang=js&"
import style0 from "./Bean.vue?vue&type=style&index=0&id=db59e550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db59e550",
  null
  
)

export default component.exports